__turbopack_context__.v({
  "product-body": "xV7o0G_product-body",
  "product-body__description": "xV7o0G_product-body__description",
  "product-body__description-list": "xV7o0G_product-body__description-list",
  "product-body__icons": "xV7o0G_product-body__icons",
  "product-body__icons--gas": "xV7o0G_product-body__icons--gas",
  "product-icon": "xV7o0G_product-icon",
});
